import React from 'react'
import { Grid, Card, CardMedia, useMediaQuery, useTheme, Typography, CardContent} from '@material-ui/core'
import useStyles from '../Styles'

function SideContent() {
    const useStyle = useStyles();
    const theme = useTheme();
    const small = useMediaQuery(theme.breakpoints.down('xs'));
    return(
        <Grid container direction={small?'row':'column'} spacing={1} className={useStyle.sideContent} >
            <Grid item xs={6} sm={12} className={useStyle.sidePhoto}>
                <Card>
                    <CardMedia component='img' height='100%' image={require('../img/pp.jpg').default}/>
                </Card>
            </Grid>
            <Grid item xs={6} sm={12} className={useStyle.sideWriting}>
                <Card raised>
                    <CardContent>
                        <Typography gutterBottom variant='h5' component='div'>
                          Hi!~ I'm Kevin~
                        </Typography>
                        <Typography variant='body2' color='textSecondary'>
                            and welcome to my website~
                            <br/>
                            I'm an in love with web developing and aim to be full stack developer someday.
                            <br/>
                            I like dogs, cats, and kids~
                            <br/>
                            Currently in Taiwan, and if you interested to work with me or need me for some code work, feel free to contact me`
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>            
        </Grid>
    )
}

export default SideContent;